































import { Component, Vue, Prop, Model } from 'vue-property-decorator';
import { FitInput } from '@tencent/wphk-ui';
@Component({
  components: {
    FitInput,
  },
})
export default class FitSearchBar extends Vue {
  @Prop({ default: '搜索' }) public searchPlaceholder!: string;
  @Prop({ default: '取消' }) public cancelText!: string;
  @Model('change') public readonly value!: string[] | number[];
  public isFocus = false;
  public cancel() {
    this.$emit('cancel');
    this.clear();
    // @ts-ignore
    this.$refs.input.blur();
  }
  public clear() {
    this.onInput('');
  }
  public onInput(val: any) {
    document.body.scrollTop = document.body.scrollTop;
    this.$emit('change', val);
  }
  public onFocus() {
    this.isFocus = true;
    this.$emit('focus');
  }
  public onBlur() {
    this.isFocus = false;
    this.$emit('blur');
  }
}
